import Component from '../core/Component';

export default class Donuts extends Component {

    constructor(element) {
        super(element);

        this.options = {
            delay: 7000
        };

        this.index = 0;
        this.count = this.ref.items.length;
        this.prevIndex = null;
    }

    require = async function() {
        const TweenLite = await import('TweenLite');
        await import('CSSPlugin');
        await import('EasePack');
        return TweenLite;
    }

    prepare(TweenLite) {
        this.ref.next.addEventListener('click', event => {
            this.stopTimer();
            this.next();
        });
        this.ref.previous.addEventListener('click', event => {
            this.stopTimer();
            this.previous();
        });

        document.addEventListener("keydown", (event) => {
            event = event || window.event;
            this.stopTimer();
            if (event.keyCode == 37) {
                this.previous();
            }
        });

        document.addEventListener("keydown", (event) => {
            event = event || window.event;
            this.stopTimer();
            if (event.keyCode == 39) {
                this.next();
            }
        });

        this.ref.numberTotal.innerHTML = this.count;
        this.select(0);
        this.timer = this.setTimer();
    }

    select(num) {
        this.index = num;
        this.render();
    }

    next() {
        this.prevIndex = parseInt(this.index);

        this.index++;
        if (this.index >= this.count) {
            this.index = 0;
        }
        this.render();
    }

    previous() {
        this.prevIndex = parseInt(this.index);

        this.index--;
        if (this.index < 0) {
            this.index = this.count-1;
        }
        this.render();
    }

    render() {
        if (this.isAnimating) {
            return;
        }

        this.element.classList.add('is-changing');
        this.isAnimating = true;

        this.ref.items.forEach(item => item.classList.remove('is-active'));
        this.ref.items[this.index].classList.add('is-active');

        if (this.prevIndex != null) {
            this.deactivate(this.ref.items[this.prevIndex]);
        }
        this.activate(this.ref.items[this.index]);

        setTimeout(() => {
            this.isAnimating = false;
        }, 800);
        this.ref.numberCurrent.innerHTML = this.index+1;
        this.ref.numberCurrent.classList.add('updated');
        setTimeout(() => {
            this.ref.numberCurrent.classList.remove('updated');
        }, 10)
    }

    setTimer() {
        return setInterval(() => {
            this.next();
            this.resetTimeline();
        }, this.options.delay)
    }

    stopTimer() {
        this.ref.timer.classList.add('stopped');
        clearInterval(this.timer);
    }

    resetTimeline() {
        this.ref.timer.classList.add('reset');
        setTimeout(() => {
            this.ref.timer.classList.remove('reset');
        }, 10)
    }

    destroy() {
        this.stopTimer();
    }

    activate(element) {
        let logo = element.querySelector('h2 span');
        let figure = element.querySelector('figure');
        let circle = element.querySelector('.donuts__circle svg');

        setTimeout(() => {
            TweenLite.fromTo(logo, .4, {
                opacity: 0,
                transform: "scale(0.8, 1)",
            }, {
                opacity: 1,
                transform: "scale(1, 1)",
                ease: Back.easeOut.config(1.8),
            });
        }, 240);

        setTimeout(() => {
            TweenLite.fromTo(figure, .5, {
                opacity: 0,
                transform: "scale(1.4)"
            }, {
                opacity: 1,
                transform: "scale(1)"
            });
        }, 300)

        TweenLite.fromTo(circle, 1, {
            opacity: .6,
            transform: "scale(0.4) translate3d(-50%, -50%, 0)"
        }, {
            opacity: 1,
            transform: "scale(1) translate3d(-50%, -50%, 0)",
            ease: Back.easeOut.config(1.4),
        });
    }

    deactivate(element) {
        let prevLogo = element.querySelector('h2 span');
        let prevFigure = element.querySelector('figure');
        let prevCircle = element.querySelector('.donuts__circle svg');

        TweenLite.fromTo(prevLogo, .9, {
            opacity: 1,
            transform: "translate3d(0, 0, 0) scale(1, 1)"
        }, {
            opacity: .4,
            transform: "translate3d(0, 200px, 0)"
        });

        setTimeout(() => {
            TweenLite.fromTo(prevFigure, .5, {
                opacity: 1,
                transform: "scale(1)"
            }, {
                opacity: 0,
                transform: "scale(1.1)"
            });
        }, 100)

        TweenLite.fromTo(prevCircle, 2, {
            opacity: 1,
            transform: "scale(1) translate3d(-50%, -50%, 0)"
        }, {
            opacity: .8,
            transform: "scale(8) translate3d(-50%, -50%, 0)"
        });
    }

}




// WEBPACK FOOTER //
// ./components/Donuts.js